import { makeStyles, Typography } from "@material-ui/core";
import React from "react";
import Box from "@material-ui/core/Box";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import { CircularProgress } from "@material-ui/core";

const useStyles = makeStyles(() => ({
	noteHeading: {
		fontWeight: "600",
	},
	subHeadingName: {
		color: "dimgray",
	},
	subHeadingStatus: {
		color: "gray",
		fontWeight: "600",
	},
	deleteIcon: {
		color: "red",
	},
}));

const Note = (props) => {
	const classes = useStyles();

	const {
		avatarProps,
		heading,
		subHeading,
		appStatus,
		description,
		showDeleteIcon,
		handleDelete,
		isLoading,
	} = props;

	return (
		<Box sx={{ marginTop: 10 }}>
			<Box sx={{ display: "flex", flexDirection: "row" }}>
				<Box>
					<Avatar {...avatarProps} />
				</Box>
				<Box sx={{ marginLeft: 10 }} flexGrow={1}>
					<Typography className={classes.noteHeading}>{heading}</Typography>
					<Typography>
						<span className={classes.subHeadingName}>{subHeading}</span>{" "}
						<span className={classes.subHeadingStatus}>@{appStatus}</span>
					</Typography>
				</Box>
				<Box>
					{showDeleteIcon && (
						<>
							{isLoading ? (
								<CircularProgress size={20} />
							) : (
								<IconButton
									edge="start"
									className={classes.deleteIcon}
									onClick={() => handleDelete()}
									aria-label="home">
									<DeleteOutline />
								</IconButton>
							)}
						</>
					)}
				</Box>
			</Box>
			<Box sx={{ marginTop: 6 }}>
			<Typography>
				<span>{description}</span>
			</Typography>
				</Box>
		</Box>
	);
};

export default Note;
